<template>
  <div class="header-wrap">
    <nav-bar
      :title="title"
      :left-arrow="leftArrow"
      @click-left="onClickLeft"
      @click-right="$emit('clickRight')"
      :right-text="rightText"
      :left-text="leftText"
    >
      <template
        #left
        v-if="$slots.left"
      >
        <slot name="left"></slot>
      </template>
      <template
        #right
        v-if="$slots.right"
      >
        <slot name="right"></slot>
      </template>
      <template
        #title
        v-if="$slots.title"
      >
        <slot name="title"></slot>
      </template>
    </nav-bar>
  </div>
</template>

<script>
import { NavBar } from "vant";
export default {
  name: "VanHeader",
  props: {
    title: {
      default: "",
    },
    rightText: {
      default: "",
    },
    leftText: {
      default: "",
    },
    click: {
      default: "",
    },
    leftArrow: {
      default: true,
    },
  },
  methods: {
    onClickLeft() {
      if (typeof this.click === "function") {
        this.click();
      } else {
        this.$router.back();
      }
      this.$emit("clickLeft");
    },
  },
  components: {
    NavBar,
  },
};
</script>

<style lang="less" scoped>
.header-wrap {
  &::after {
    height: 46px;
    width: 100%;
    display: block;
    content: " ";
  }
}
/deep/ .van-nav-bar {
  position: fixed;
  width: 100%;
  z-index: 1000 !important;
  background: #da373c;
  .van-nav-bar__title {
    color: #ffffff !important;
  }
  .van-icon {
    color: #ffffff !important;
  }
  .van-nav-bar__text {
    color: #fff;
    font-size: 0.2rem;
  }
  &::after {
    border: 0;
  }
}
</style>
